import React from "react";
import { Provider } from "react-redux";
import store from "../redux/index"; // Import your Redux store

export const ReduxWrapper = ({ children }: { children: React.ReactNode }) => {
  return <Provider store={store}>{children}</Provider>;
};